interface IScope extends ng.IScope {
  loading: boolean;
}
export class InfiniteScroll implements ng.IDirective {
  public restrict = 'A';

  public link(scope: IScope, elem: JQuery, attrs: ng.IAttributes) {
    let raw = elem[0];

    elem.bind("scroll", function(){
      if(raw.scrollTop+raw.offsetHeight+5 >= raw.scrollHeight){
        scope.loading = true;
        scope.$apply(attrs.infiniteScroll);
      }
    });
  }
}
